import {
    EasyVrpCalculationApi,
    type EasyVrpCalculationResponseType,
} from './EasyVrpCalculationApi';
import { Api } from '@automapa/svelte-automapa-template';

export class EasyVrpResultApp {
    private resultList: EasyVrpCalculationResponseType[] = []; // this should be simplified for performance (without input and output)
    private resultDetails: EasyVrpCalculationResponseType | null = null;

    public async loadResults(api: Api): Promise<EasyVrpCalculationResponseType[]> {
        this.resultList = await EasyVrpCalculationApi.getHistoryAll(api).catch(error => {
            console.error('Error loading VRP calculation history:', error);
            return [];
        });
        console.log('Loaded VRP calculation history:', this.resultList);
        return this.resultList;
    }

    public async loadResultDetails(
        api: Api,
        id: number
    ): Promise<EasyVrpCalculationResponseType | null> {
        if (this.resultDetails && this.resultDetails.id === id) {
            return this.resultDetails; // Return cached details if already loaded
        }
        this.resultDetails = await EasyVrpCalculationApi.getHistorySingle(api, id).catch(error => {
            console.error('Error loading VRP calculation details:', error);
            return null;
        });
        return this.resultDetails;
    }

    public getResults(): EasyVrpCalculationResponseType[] {
        return this.resultList;
    }

    public getResultDetails(): EasyVrpCalculationResponseType | null {
        return this.resultDetails;
    }

    public async deleteResult(api: Api, id: number): Promise<void> {
        this.resultList = this.resultList.filter(result => result.id !== id);
        this.resultDetails = this.resultDetails?.id === id ? null : this.resultDetails;
        EasyVrpCalculationApi.removeOne(api, id).catch(error => {
            console.error('Error deleting VRP calculation:', error);
        });
    }

    public upsertResult(result: EasyVrpCalculationResponseType): void {
        const index = this.resultList.findIndex(r => r.id === result.id);
        if (index !== -1) {
            this.resultList[index] = result;
        } else {
            this.resultList.push(result);
        }
    }

    public updateProgressFloat(calc_id: number, progress_float: number): void {
        const index = this.resultList.findIndex(r => r.id === calc_id);
        if (index !== -1) {
            this.resultList[index].progress_float = progress_float;
        } else {
            console.warn(`Calculation with ID ${calc_id} not found for progress update.`);
        }
    }

    public setCalculationAssigned(calc_id: number) {
        // clear assigned timestamp in all other calculations
        this.resultList.forEach(result => {
            if (result.id !== calc_id) {
                result.assigned = null;
            }
        });
        // set assigned timestamp for the given calculation
        const index = this.resultList.findIndex(r => r.id === calc_id);
        if (index !== -1) {
            this.resultList[index].assigned = new Date().toISOString();
        }
    }
}
